<template>
  <div class="fixed inset-0 overflow-hidden bg-gray-400 bg-opacity-50" style="z-index: 998;" >
    <modal :modal="modal"></modal>
    <div class="absolute inset-0 overflow-hidden">
      <section :class="[ centered ? 'max-w-full justify-center flex' : 'absolute inset-y-0 right-0 pl-10 max-w-full flex']">
        <div class="w-screen max-w-5xl">
          <div class="h-screen flex flex-col bg-white shadow-xl overflow-hidden">
            <header class="space-y-1 py-2 px-2 bg-blue-700">
              <div class="flex items-center justify-between">
                <div class="text-white flex flex-row">
                  <div v-on:click="refresh" class="hover:bg-white hover:text-blue-800 px-2 py-1 border border-blue-300 rounded font-bold flex flex-col justify-center text-md text-blue-300 cursor-pointer">
                    <i class="fa fa-sync-alt"></i>
                  </div>
                  <div v-on:click="save" class="ml-4 hover:bg-white hover:text-blue-800 px-6 py-1 border border-white rounded font-bold flex flex-col justify-center text-md cursor-pointer">
                    Save
                  </div>
                  <div class="ml-4 px-6 py-1 border border-blue-500 bg-blue-500 rounded font-bold flex flex-col justify-center text-md">New</div>

                  <div @click="goToCustomer" class="py-1 ml-4 leading-tight flex flex-col justify-center bg-blue-50 px-2 text-blue-700 rounded cursor-pointer" style="min-width: 200px;">
                    <span class="font-bold">Michael Devenijn</span>
                    9820 Bottelare
                  </div>

                </div>
                <div class="h-6 flex items-center">
                  <div class="text-white text-md mr-6">
                    <div class="font-bold"></div>
                  </div>
                  <button aria-label="Close panel" class="text-blue-100 hover:text-white transition ease-in-out duration-150 px-1 mr-2" @click="toggleCenter">
                    <i class="fas fa-arrows-alt-h"></i>
                  </button>
                  <button aria-label="Close panel" class="text-blue-100 hover:text-white transition ease-in-out duration-150" @click="close">
                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6 w-6">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                  </button>
                </div>
              </div>
            </header>
            <div v-if="$store.getters['sales/loading']" class="flex flex-col h-full">
              <loading></loading>
            </div>
            <div class="relative flex-1 overflow-y-scroll w-full">
              <sales-header></sales-header>
              <div class="flex flex-row w-full">
                <side-menu></side-menu>
                <customer-start v-if="$store.getters['sales/menu'] === 'customer' && $store.getters['sales/buyerActive']"></customer-start>
                <customer v-if="$store.getters['sales/menu'] === 'customer' && !$store.getters['sales/buyerActive']"></customer>
                <catalog v-if="$store.getters['sales/menu']==='catalog'"></catalog>
                <proposal v-if="$store.getters['sales/menu']==='proposal'"></proposal>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import loading from "@/components/loading";
import {modalInfo} from "@/common/modal";
import modal from "@/components/modal";
import Customer from "@/sales/views/sales/Customer";
import CustomerSearch from "@/sales/views/search/Customer";
import Header from "@/sales/views/sales/Header";
import SideMenu from "@/sales/views/sales/Side";
import Catalog from "@/sales/views/sales/Catalog";
import Proposal from "@/sales/views/sales/Proposal";

export default {
  name: "Detail",
  components : {
    'loading': loading,
    'modal': modal,
    'sales-header': Header,
    'side-menu': SideMenu,
    'customer': Customer,
    'customer-start': CustomerSearch,
    'catalog': Catalog,
    'proposal': Proposal
  },
  data() {
    return {
      centered: true,
      detailMenu: null,
      pictures: [],
      modal: modalInfo()
    }
  },
  methods: {
    toggleCenter() {
      this.centered = !this.centered;
    },
    goToCustomer() {

    },
    save() {

    },
    refresh() {
      this.modal.color = 'orange';
      this.modal.view('sale Lead', 'Are you sure to reload the file and eventually loose data ?', 'Reload', 'exclamation-triangle', () => {
        this.$store.commit('sales/openItem', this.$store.getters['sales/lead'].leadId);
      })
    },
    close() {
      this.$store.commit("master/closeDetail");
    }
  }
}
</script>

<style scoped>

</style>